import moment from 'moment';
import lottie from 'lottie-web';

import { getRenderPeriodData } from '../../app/Helper/PeriodHelper';

/**
 * @export
 * @class Duration
 * 타임 스케쥴딜의 시간 타이머 레이어
 */
export default class TimeScheduleInfo {
  GET_SERVER_TIME_START_MIN = 5;

  // x분 남았을때 서버 타임이랑 동기화를 시작한다.
  GET_SERVER_TIME_INTERVAL = 10; // 서버타임 동기화 시작할때 x초마다 동기화 한다.

  MAX_TIMER_ALARM_COUNT = 10;

  WHEN_CANNOT_TOGGLE_TIMER_ALARM =
    '지금은 알림 설정 또는 취소가 불가능합니다.\n(사전알람 신청은 딜판매 24시간전부터 20분 전까지만 가능)';

  WHEN_USER_TIMER_ALARM_COUNT_MORE_THAN_10 =
    '딜 오픈 알림은 최대 10개까지\n등록할 수 있습니다.';

  bInitialized = false;

  currentTime = null;

  dealNo = 0;

  constructor() {
    const { type, data } = getRenderPeriodData();
    if (type !== 'time') {
      return;
    }

    const { scheduleShowType, dealStartTime, dealEndTime, dealNo } = data;

    this.scheduleShowType = scheduleShowType;
    this.dealStartTime = dealStartTime;
    this.dealEndTime = dealEndTime;
    this.dealNo = dealNo;
    this.serverTime();
  }

  ajaxForTimerAlarm = (type, isForCount) =>
    $.ajax({
      type,
      url: `${TMON.htLocal.htURL.dealAlarm}${
        isForCount ? '' : `/${this.dealNo}`
      }?useHeader=MN`,
    }).then(
      data => data.data,
      () => false
    );

  isMoreThan20MinutesAndLessThan24Hours = () => {
    const isMoreThan20Minustes =
      this.getTimeDiff(this.dealStartTime, this.currentTime, 'minutes') > 19;
    const isLessThan24Hours =
      this.getTimeDiff(this.dealStartTime, this.currentTime, 'hours') < 24;

    return isMoreThan20Minustes && isLessThan24Hours;
  };

  isLogin = () => TMON.bLogin;

  isWeb = () => TMON.sDevice === 'PW' || TMON.view_mode === 'web';

  getPlatform = () => {
    if (this.isWeb()) {
      return TMON.sDevice === 'PW' ? 'PC_PW' : 'MW';
    }

    return TMON.bIsIos ? 'IOS' : 'AD';
  };

  init() {
    this.cacheElement();
    this.setLottieData();

    if (this.currentTime.isBefore(this.dealStartTime) || this.isCacheData()) {
      // 판매 시작전
      this.setBeforeSellEnv();
    } else if (this.currentTime.isBefore(this.dealEndTime)) {
      // 판매 시작후
      this.setAfterSellEnv();
      this.welTimerBell.removeClass('on off');
    } else {
      // 행사 종료
      this.setAfterSellEnv();
    }

    this.setEvent();
    this.runIntervalJob();

    let temp = new Date().getTime();

    this.nInterval = setInterval(async () => {
      if (new Date().getTime() - temp >= 2000) {
        await this.serverTime();
        this.runIntervalJob();
      } else {
        this.runIntervalJob();
      }

      temp = new Date().getTime();
    }, 1000);

    this.bInitialized = true;

    this.welWrapper.show();
    this.welSideWrap.show();
    this.welBody.addClass('timer_deals'); // 'x명이 보고있어요' 케릭터 레이어 위치를 위로 올리기위한 클래스 추가
  }

  getDayDiff(oA, oB) {
    const newA = moment(oA.format('YYYY-MM-DD'));
    const newB = moment(oB.format('YYYY-MM-DD'));
    return newA.diff(newB, 'days');
  }

  getTimeDiff = (oA, oB, type) => oA.diff(oB, type);

  runIntervalJob() {
    this.renderTime();
    this.showReloadLayer();
    this.checkServerTime();
    this.currentTime.add('1', 'seconds');
  }

  /**
   * 판매 시작전 환경 설정
   */
  async setBeforeSellEnv() {
    this.isBeforeSell = true;
    this.targetTime = this.dealStartTime;
    $('[data-role=topTimeText]').text('오픈까지 남은시간');
    this.welSideWrap.removeClass('open');
    this.welSideWrap
      .find('[data-role=sideTimeText]')
      .html(TMON.oApp.sPlatform === 'PW' ? '오픈까지 남은시간' : '남은시간');
    /* eslint-disable no-underscore-dangle */
    if (
      this.isWeb() ||
      (!this.isWeb() && TMON.app._isValidAppVersion('4.9.2'))
    ) {
      this.addOffClassAtTimerAlarm();

      if (this.isLogin()) {
        const hasTimerAlarm = await this.ajaxForTimerAlarm('GET');

        if (hasTimerAlarm) {
          this.addOnClassAtTimerAlarm();
        }
      }
    }
  }

  addOnClassAtTimerAlarm() {
    this.welTimerBell.removeClass('off').addClass('on');
    this.animateLottie('activated');
  }

  addOffClassAtTimerAlarm(state = 'normal') {
    this.welTimerBell.removeClass('on').addClass('off');
    this.animateLottie(state);
  }

  /**
   * 판매 시작후 환경 설정
   */
  setAfterSellEnv() {
    this.isBeforeSell = false;
    this.targetTime = this.dealEndTime;
    $('[data-role=topTimeText]').text('행사종료 남은시간');
    this.welWrapper.find('.timer_icon').hide();
    this.welWrapper.find('.timer_watch_icon').hide();
    this.welReloadLayer.remove();
    this.welSideWrap.addClass('open');
    this.welSideWrap.find('[data-role=sideTimeText]').html('남은시간');
    this.welSideWrap.find('.timer_icon').hide();
    this.welSideWrap.find('.timer_watch_icon').hide();
  }

  cacheElement() {
    this.nServerTimeCount = 0;
    this.welBody = $('body');
    this.welWrapper = $('#_timeScheduleWarp');
    this.welHoursWrap = $('.timer_numbers_num[data-role=timeLimitHours]');
    this.welDaysWrap = $('[data-role=timeLimitDays]');
    this.welReloadLayer = $('[data-role=timeReloadLayer]');
    this.welGoHomeLayer = $('[data-role=timeGoHomeLayer]');
    this.welSideWrap = $('#_timeSchSide');
    this.welTimerNotice = $('.timer_notice');
    this.welTimerBell = $('[data-role=timerBell]');
    this.welTimerBellIcon = $('.timer_bell_icon');
    this.welAlarmRegister = $('[data-role=alarmRegister]');
    this.welAlramSetting = $('[data-role=alarmSetting]');
    this.welAlarmCloseAndConfirm = $(
      '[data-role=alarmClose], [data-role=alarmConfirm]'
    );
  }

  setEvent() {
    $('[data-role=refreshPage]').on('click', () => {
      window.location.reload();
      return false;
    });

    this.welGoHomeLayer.on('click', 'a', () => {
      if (TMON.view_mode === 'app') {
        TMON.app.callApp('webview', 'goHome');
        return false;
      }

      return true;
    });

    this.welTimerBell.click(async e => {
      TMON.sendLog(
        [
          `${this.getPlatform()}_AreaTrack`,
          'click',
          `DealOpenAlarm_${
            e.currentTarget.classList.contains('on') ? 'on' : 'off'
          }`,
        ],
        [e.currentTarget, e, { 'tl:area': 'DOAB' }]
      );

      if (this.isLogin()) {
        const hasTimerAlarm = await this.ajaxForTimerAlarm('GET');

        if (!hasTimerAlarm) {
          if (this.isMoreThan20MinutesAndLessThan24Hours()) {
            const userTimerAlarmCount = await this.ajaxForTimerAlarm(
              'GET',
              true
            );

            if (userTimerAlarmCount.length < this.MAX_TIMER_ALARM_COUNT) {
              const is200 = await this.ajaxForTimerAlarm('POST');

              if (is200) {
                this.addOnClassAtTimerAlarm();

                if (TMON.oApp.sPlatform === 'PW') {
                  this.welAlarmRegister.show();
                } else {
                  TMON.oApp.oUtil.handleOpenLayer({
                    welTargetLayer: this.welAlarmRegister,
                  });
                }
              }
            } else {
              window.alert(this.WHEN_USER_TIMER_ALARM_COUNT_MORE_THAN_10);
            }
          } else {
            window.alert(this.WHEN_CANNOT_TOGGLE_TIMER_ALARM);
          }
        }

        if (hasTimerAlarm) {
          if (this.isMoreThan20MinutesAndLessThan24Hours()) {
            const is200 = await this.ajaxForTimerAlarm('DELETE');

            if (is200) {
              this.addOffClassAtTimerAlarm('disabled');
            }
          } else {
            window.alert(this.WHEN_CANNOT_TOGGLE_TIMER_ALARM);
          }
        }
      } else {
        if (this.isWeb()) {
          TMON.oApp.oUtil.login();
          return;
        }

        TMON.app.callApp('webview', 'login', true);
      }
    });

    this.welAlarmCloseAndConfirm.click(() => {
      if (TMON.oApp.sPlatform === 'PW') {
        this.welAlarmRegister.hide();
      }
    });

    if (this.welAlramSetting) {
      this.welAlramSetting.click(() => {
        TMON.app.callApp('webview', 'goAppAlarmSetup');
      });
    }
  }

  changeTimerClass(remainingSeconds) {
    if (remainingSeconds > 30 && remainingSeconds < 301) {
      return ' time_start';
    }

    if (remainingSeconds > 0 && remainingSeconds <= 30) {
      return ' time_soon';
    }

    if (remainingSeconds === 0) {
      return ' time_end';
    }

    return '';
  }

  renderTime() {
    const setTimeFormat = t => (t < 10 ? ['0', t].join('') : t);
    const mils = this.targetTime.diff(this.currentTime, 'miliseconds');
    const bIsPassed = mils <= 0; // 시간이 지났는지 체크
    const oDiff = moment.duration(this.targetTime.diff(this.currentTime));

    const days = bIsPassed ? 0 : Math.floor(oDiff.asDays());
    const hours = bIsPassed ? '00' : setTimeFormat(oDiff.hours() + days * 24);
    const mins = bIsPassed ? '00' : setTimeFormat(oDiff.minutes());
    const secs = bIsPassed ? '00' : setTimeFormat(oDiff.seconds());

    if (days >= 1) {
      // 1일 이상의 경우 x일로 표시
      this.welDaysWrap
        .html(
          `${this.getDayDiff(
            this.targetTime,
            this.currentTime
          )}<span class="timer_numbers_text">일 남음</span>`
        )
        .show();
      this.welHoursWrap.hide();
    } else {
      if (this.scheduleShowType === 'SECOND' && !this.isBeforeSell) {
        const remainingSeconds = moment
          .duration(`${hours}:${mins}:${secs}`)
          .asSeconds();
        const className = this.changeTimerClass(remainingSeconds);

        this.welSideWrap
          .removeClass()
          .addClass(`timer${TMON.sDevice === 'MW' ? '' : ' side'}${className}`);
        this.welWrapper.removeClass().addClass(`timer${className}`);

        if (className) {
          this.welWrapper.find('.timer_watch_icon').show();
          this.welSideWrap.find('.timer_watch_icon').show();
        }

        this.welHoursWrap.html(
          `${remainingSeconds
            .toString()
            .padStart(3, 0)}초 남음<span class="blind">초 남음</span>`
        );
      } else {
        this.welHoursWrap
          .html(
            `${hours}<span class="blind">시</span>:${mins}<span class="blind">분</span>:${secs}<span class="blind">초 남음</span>`
          )
          .show();
      }

      this.welDaysWrap.hide();
    }

    // 판매중일 때 시간이 지나면 레이어 창을 띄워준다.
    if (bIsPassed && this.isBeforeSell === false) {
      this.welGoHomeLayer.show();
    }

    // 판매전일 때 시간이 지나면 텍스트 변경
    if (bIsPassed && this.isBeforeSell === true) {
      $('[data-role=timeReloadTitle]').text('행사상품이 오픈했습니다!');
      $('[data-role=timeReloadContext]').text('새로고침을 누르십시오.');
    }

    // 시간이 지났으면 인터벌 제거
    if (bIsPassed) {
      clearInterval(this.nInterval);
    }
  }

  showReloadLayer() {
    if (!this.isBeforeSell) {
      return;
    }
    const diffSec = this.targetTime.diff(this.currentTime, 'seconds');

    if (diffSec <= 10) {
      this.welReloadLayer.show();
      $('.toast.boxtype').remove(); // 리로드 레이어가 떠있을 때는 'x명이 보고있어요' 케릭터 레이어가 나오면 안된다.
    } else {
      this.welReloadLayer.hide();
    }
  }

  checkServerTime() {
    const diffMin = this.targetTime.diff(this.currentTime, 'minutes');

    if (diffMin < this.GET_SERVER_TIME_START_MIN) {
      // 5분 이하일 때만 서버타임을 업데이트 한다.
      this.getServerTime();
    }
  }

  getServerTime() {
    if (this.nServerTimeCount < this.GET_SERVER_TIME_INTERVAL) {
      // 10초에 한번씩 서버시간으로 업데이트
      this.nServerTimeCount += 1;
      return;
    }

    this.nServerTimeCount = 0;

    this.serverTime();
  }

  serverTime() {
    $.ajax({
      type: 'GET',
      url: TMON.htLocal.htURL.localeUrl,
      data: {
        time: Math.random(),
      },
      success: (a, b, request) => {
        this.currentTime = moment(
          request
            .getResponseHeader('x-current-time')
            .replace(/\+[0-9]{2}:[0-9]{2}/, '')
            .replace('T', ' ')
        );
        if (!this.bInitialized) {
          this.init();
        }
      },
    });
  }

  /* 딜 알람 bell lottie 관련 script 추가 */
  setLottieData() {
    this.welTimerBellLottie = [];
    this.welTimerBellIcon.each((index, icon) => {
      const lottieAni = {
        container: icon,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: this.getLottieDataPath(),
        rendererSettings: {
          clearCanvas: false,
          progressiveLoad: false,
        },
      };
      this.welTimerBellLottie.push(lottie.loadAnimation(lottieAni));
    });

    this.welTimerBellLottie.forEach(lottieEl => {
      lottieEl.addEventListener('DOMLoaded', () => {
        this.animateLottie();
      });
    });
  }

  getLottieDataPath() {
    return `${TMON.htLocal.htURL.resourcePath}/img/deals/ico_bell_animation.json`;
  }

  isCacheData() {
    const isBetween = this.currentTime.isBetween(
      this.dealStartTime,
      this.dealEndTime
    );

    return TMON.oApp.htStorage.htStaticData.isBeforeOpen && isBetween;
  }

  /* eslint-disable no-param-reassign */
  // 프레임 : 1-30(기본), 31-60(알람 선택), 61-90(선택 해제)
  animateLottie(state = 'normal') {
    this.welTimerBellLottie.forEach(lottieEl => {
      switch (state) {
        case 'normal':
          lottieEl.playSegments([1, 30], true);
          break;
        case 'activated':
          lottieEl.playSegments([31, 60], true);
          break;
        case 'disabled':
          lottieEl.goToAndPlay(61, true);
          lottieEl.playSegments([1, 30], false);
          break;
        default:
          lottieEl.playSegments([1, 30], true);
          break;
      }
    });
  }
  /* eslint-disable no-param-reassign */
}
